// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-list[data-v-f99fc18c]{display:flex}.button-list button[data-v-f99fc18c]{margin-right:12px}.shop-contact-icon[data-v-f99fc18c]{display:flex;height:-moz-fit-content;height:fit-content;margin-right:12px}.shop-contact-icon img[data-v-f99fc18c]{border-radius:0;height:32px;width:42px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
